import React, { FC } from 'react';
import { IQuestion } from '@kilornd/api-wrapper';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { AppState } from 'state/types';

import ChecklistItem from 'pages/start/results/components/ChecklistItem';
import { mobile } from 'styles/breakpoints';

import { Text } from 'components';
import ContinueButton from './QuizContinueButton';
import { formatCost } from 'utils/functions';

interface CostProps {
  question: IQuestion;
  onContinue: ({ value, label }: { value: string; label: string }) => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const CardContainer = styled.div`
  width: 100%;
  max-width: 22.5rem;
  padding: 1.5rem 2rem;

  background: #fafafa;
  border: 1px solid #f4f4f4;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.08);
  border-radius: 16px;

  @media ${mobile} {
    padding: 1rem;
  }
`;

const Title = styled(Text)`
  margin: 1.5rem 0;
`;

const CostText = styled(Text)<{ color?: string }>`
  color: ${({ color }) => color};
`;

const Per = styled(Text)`
  margin-bottom: 1.5rem;
`;

const CardTitle = styled(Text)`
  text-align: center;
`;

const Cost: FC<CostProps> = ({ question, onContinue }) => {
  const { quiz_answers } = useSelector((state: AppState) => state.user);
  const {
    title,
    costAnswerKey,
    costAnswerMultiplier,
    costColor,
    costUnit,
    per,
    cardTitle,
    cardBenefits,
  } = question;
  const costAnswer = parseInt(quiz_answers[costAnswerKey] || '0');
  const multpliedCostAnswer = costAnswerMultiplier
    ? costAnswer * costAnswerMultiplier
    : costAnswer;

  const renderChecklist = (item: string, index: number) => (
    <ChecklistItem
      label={item}
      key={index}
      margin="0.75rem 0 0 0"
      marginBot={false}
      circleSize={1}
    />
  );

  return (
    <Container>
      <Title type="h3">{title}</Title>
      <CostText type="h13Rem" color={costColor}>
        {costUnit}
        {formatCost(multpliedCostAnswer)}
      </CostText>
      <Per type="body" color="dark60">
        {per}
      </Per>
      <CardContainer>
        <CardTitle type="body700">{cardTitle}</CardTitle>
        {cardBenefits.map(renderChecklist)}
      </CardContainer>
      <ContinueButton title={question?.nextBtnTitle} onClick={onContinue} />
    </Container>
  );
};

export default Cost;
